export default function menuDirective(MenuService, $window, User, environment, $location) {
  'ngInject';
  return {
    restrict: 'E',
    templateUrl: 'app/components/menu/menu.html',
    scope: {
      close: '&'
    },
    link: function ($scope, $element) {

      $scope.userService = User;

      $scope.isAdmin = false;
      $scope.baseUrl = environment.site.parent;
      $scope.newUrl = environment.site.new;

      $scope.menuShows = [];
      $scope.menuCategories = [];

      $scope.toggleSubMenu = (event, menuItem) => {
        let element = event.target;

        if ($scope.activeMenu === menuItem) {
          if (element.innerHTML.toLowerCase() !== 'more' && $location.path() !== `/element.innerHTML.toLowerCase()`) {
            $window.location.href = `${$scope.newUrl}/${element.innerHTML.toLowerCase()}`;
          } else {
            $scope.activeMenu = NaN;
          }
        } else {
          $scope.activeMenu = menuItem;
        }
      }

      $scope.$watch(function () {
          return User.loggedIn();
        },
        function () {
          MenuService.getMenuTitle().then(res => {
            $scope.loading = false;
            $scope.menuItems = res.data;
          });

            User.getUser().then(res => {
              if (res) {
                $scope.isAdmin = res.is_admin;
              }
            });
        });

      $scope.loading = true;
    }
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/components/menu/menu.directive.js
 **/